import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card"
import { Textarea } from "components/ui/textarea"
import { ChevronDown, ChevronUp } from "lucide-react"

interface GlobalNoteCardProps {
  selectedCount: number
  isExpanded: boolean
  note: string
  onToggle: () => void
  onNoteChange: (value: string) => void
}

const MAX_LENGTH = 500

export const GlobalNoteCard = ({
  selectedCount,
  isExpanded,
  note,
  onToggle,
  onNoteChange
}: GlobalNoteCardProps) => {
  return (
    <Card>
      <CardHeader
        className="p-3 cursor-pointer hover:bg-gray-50"
        onClick={onToggle}
      >
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium">
            Observação Global ({selectedCount} item(s))
          </CardTitle>
          {isExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </div>
      </CardHeader>
      {isExpanded && (
        <CardContent className="p-3 pt-0">
          <Textarea
            placeholder="Observação aplicada a todos os itens selecionados..."
            value={note}
            onChange={(e) => onNoteChange(e.target.value)}
            className="min-h-[60px] resize-none text-sm"
            maxLength={MAX_LENGTH}
          />
          <p className="text-xs text-gray-500 mt-1">{note.length}/{MAX_LENGTH}</p>
        </CardContent>
      )}
    </Card>
  )
}
